
import React, { useEffect, useCallback, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import axios from "axios";
import { APP_BASEURL } from "../../agora.config";
import { DyteMeeting } from '@dytesdk/react-ui-kit';
import { DyteProvider, useDyteClient, useDyteMeeting, useDyteSelector } from '@dytesdk/react-web-core';

const Met=()=>{
  const { meeting } = useDyteMeeting();
  useEffect(() => {
    meeting.joinRoom();
  }, [meeting]);
  return <DyteMeeting meeting={meeting} />;

}

const Meeting = (props) => {
  const [meeting, initMeeting] = useDyteClient();
  let history = useHistory();
  const[roomName, setRoomName]=useState();
  const[token, setToken]=useState();
  const[meetingId, setMeetingId]=useState();
  const[load, setLoad]=useState(false)
  const [user, setUser]=useState()
  /* Why the call could not start. Without this the page rendered an empty
     container on any failure, which is what made a dead video provider look
     like a broken website for two days. */
  const[failure, setFailure]=useState(null)
 useEffect(()=>{
  let user = props?.location?.state?.user
  let key = props?.location?.state?.appointmentData?.appointment_n_key
  if(user&&user ==="doctor"){
   handleCreateRoomClick(key)
  }
  if(user&&user ==="patient"){
    handlePatientRoom(key)
  }
 },[])
 useEffect(() => {
  if(token&&roomName){
  initMeeting({
    authToken: token,
    defaults: {
      audio: false,
      video: false,
    },
  });
}
}, [token,roomName]);

useEffect(() => {
  if (!meeting) return;
  
  const onRoomJoined = () => {
    console.log('You have joined the room');
  };
  
  const onRoomLeft = (left) => {
    if(left?.state == 'ended' &&props?.location?.state?.user === "doctor"){
      overallStaus()
    }
    else window.location.href="/thanks"
    console.log('You have left the room',left);
  };
  
  const onParticipantJoined = (paricipant) => {
    console.log(`${paricipant.name} has joined`);
    updateArrival()
  };
  
  meeting?.self?.addListener('roomJoined', onRoomJoined);
  meeting?.self?.addListener('roomLeft', onRoomLeft);
  meeting?.participants?.joined?.addListener('participantJoined', onParticipantJoined);
  
  return () => {
    meeting?.self?.removeListener('roomJoined', onRoomJoined);
    meeting?.self?.removeListener('roomLeft', onRoomLeft);
    meeting?.participants?.joined?.removeListener('participantJoined', onParticipantJoined);
  }
}, [meeting]);

 const headers = {
  "Authorization" : "Token 70c48f814c3a6cc1b4e1dcb0ea4b2cc0713c90bf",
  'Content-Type': 'application/json'
};
 const handleCreateRoomClick=async(key)=>{
   const parameter={
    "appointment_n_key": key,
    "org_n_key" :"ORGID-1"
   }
  await axios.post( APP_BASEURL + 'api/joinroomtherapist/', parameter, {headers}).then((res)=>{
    if (!res?.data?.auth_token) {
      console.error('joinroomtherapist returned no auth token', res?.data)
      setFailure(res?.data?.reason || 'no-token')
      return
    }
    setRoomName(res.data.room_name)
    setToken(res.data.auth_token)
    setLoad(true)
    updateDoctorArrival()
  })
  .catch((err)=>{ console.error(err); setFailure('request-failed') })
 }
 const handlePatientRoom=async(key)=>{
  const parameter={
   "appointment_n_key":key,
   "org_n_key" :"ORGID-1"
  }
 await axios.post( APP_BASEURL + 'api/joinroompatient/', parameter, {headers}).then((res)=>{
   if (!res?.data?.auth_token) {
     console.error('joinroompatient returned no auth token', res?.data)
     setFailure(res?.data?.reason || 'no-token')
     return
   }
   setRoomName(res.data.room_name)
   setToken(res.data.auth_token)
   setLoad(true)
   updatePatitentArrival()
 })
 .catch((err)=>{ console.error(err); setFailure('request-failed') })
}
const updatePatitentArrival=async()=>{
  var Appointment_key=props.location.state.appointmentData.appointment_n_key
  axios.get(APP_BASEURL +`api/caremeapp/appointment_crud/${Appointment_key}/`, { headers })
  .then((res)=>{
    if(res.data.status_check == false){
  const parameter ={ 'overall_status': 'Arrived'}
  axios.put(APP_BASEURL +`api/caremeapp/appointment_crud/${Appointment_key}/`,parameter, {headers}).then((res)=>{
  }).catch((err)=>console.log(err))
  }
  })
  }
  const updateDoctorArrival=async()=>{
    var Appointment_key=props.location.state.appointmentData.appointment_n_key
    axios.get(APP_BASEURL +`api/caremeapp/appointment_crud/${Appointment_key}/`, { headers })
    .then((res)=>{
      if(res.data.status_check == false){
    const parameter ={ 'overall_status': 'Practioner_Arrived'}
    axios.put(APP_BASEURL +`api/caremeapp/appointment_crud/${Appointment_key}/`,parameter, {headers}).then((res)=>{
      console.log(res)
    }).catch((err)=>console.log(err))
    }
    })
    }
    const updateArrival=async()=>{
      var Appointment_key=props.location.state.appointmentData.appointment_n_key
      axios.get(APP_BASEURL +`api/caremeapp/appointment_crud/${Appointment_key}/`, { headers })
      .then((res)=>{
        if(res.data.status_check == false){
      const parameter ={ 'overall_status': 'With_Practioner'}
      axios.put(APP_BASEURL +`api/caremeapp/appointment_crud/${Appointment_key}/`,parameter, {headers}).then((res)=>{
        console.log(res)
      }).catch((err)=>console.log(err))
      }
      })
      }
    const overallStaus=async()=>{
      var Appointment_key=props.location.state.appointmentData.appointment_n_key
      const parameter ={ 'overall_status': 'Completed'}
      axios.put(APP_BASEURL +`api/caremeapp/appointment_crud/${Appointment_key}/`,parameter, {headers}).then((res)=>{
        console.log(res)
        window.location.href="/thanks"
      }).catch((err)=>console.log(err))
      }
   
    if (failure) {
      return (
        <div className="full videocall" style={{display:'flex',alignItems:'center',
             justifyContent:'center',minHeight:'100vh',padding:'24px',
             background:'#0f1020',color:'#fff',textAlign:'center'}}>
          <div style={{maxWidth:'420px'}}>
            <div style={{fontSize:'44px',lineHeight:1,marginBottom:'14px'}}>&#9888;</div>
            <h2 style={{fontSize:'20px',fontWeight:700,marginBottom:'10px'}}>
              We could not start the video call
            </h2>
            <p style={{fontSize:'14px',opacity:.75,lineHeight:1.6,marginBottom:'18px'}}>
              Our video service is not responding right now. This is at our end,
              not yours &mdash; your appointment is still booked. Please contact
              the clinic and they will call you back or send a fresh link.
            </p>
            <button onClick={() => window.location.reload()}
              style={{background:'#fff',color:'#0f1020',border:0,borderRadius:'999px',
                      padding:'12px 26px',fontWeight:700,cursor:'pointer',minHeight:'44px'}}>
              Try again
            </button>
            <p style={{fontSize:'11px',opacity:.4,marginTop:'16px'}}>
              Reference: {failure}
            </p>
          </div>
        </div>
      );
    }

    if (!load) {
      return (
        <div className="full videocall" style={{display:'flex',alignItems:'center',
             justifyContent:'center',minHeight:'100vh',background:'#0f1020',
             color:'#fff',fontSize:'14px',opacity:.8}}>
          Connecting you to the call&hellip;
        </div>
      );
    }

    return (
      <div>
        <DyteProvider value={meeting}>
          <Met />
        </DyteProvider>
      </div>
    );
};

export default Meeting;


  

  